import React from "react";
import PortraitDefault from "../../PortraitDefault";
import { useAuthContext } from "../../../context/auth";
import Start from "./Start";
import WarmUp from "./WarmUp";
import CoolDown from "./CoolDown";
import MainExerInfo from "./MainExerInfo";
import MainExer from "./MainExer";
import { ClubDayBadgesDetailData } from "../../../Api";
import ClubDay from "../ClubDay/ClubDay";
import ClubDayPortrait from "../ClubDay/ClubDayPortrait";

function BasicScreen({
  clubDayChunks,
}: {
  clubDayChunks: ClubDayBadgesDetailData["classAchievements"][];
}) {
  const { step, basicProgram } = useAuthContext();

  const getScreen = () => {
    const samePageFirst = [
      <PortraitDefault key={"portrait-default"} />,
      <Start key={"start"} />,
      <WarmUp key={"warm-up"} />,
    ];
    const samePageLast = [
      <CoolDown key={"cool-down"} />,
      <ClubDayPortrait key={`club-day`} data={clubDayChunks} />,
      <PortraitDefault key={"portrait-default"} />,
    ];
    const basicPages = [
      ...samePageFirst,
      <MainExerInfo key={"main-exer-info"} />,
      <MainExer key={"main-exer"} />,
      ...samePageLast,
    ];

    return basicPages[step];
  };
  return <>{getScreen()}</>;
}

export default BasicScreen;
